import React from 'react'

import useInsuranceCompanies from '../insuranceCompanies/hooks/useInsuranceCompanies'
import Filter from './Filter'
import { FILTER_INSURANCE_SLUG } from './filters.constants'

const FilterInsurance: React.FC = () => {
  const { insuranceCompanies } = useInsuranceCompanies()

  if (!insuranceCompanies || (insuranceCompanies && insuranceCompanies.length === 0)) return null

  const options = insuranceCompanies.map((insuranceCompany) => ({
    label: insuranceCompany.name,
    value: insuranceCompany.id,
  }))

  return <Filter slug={FILTER_INSURANCE_SLUG} options={options} />
}

export default FilterInsurance
